import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DistributorSortingEntityParams {
  value: string;
}
export class DistributorSortingEntity extends BaseEntityClass {
  value: string;
  constructor(params: DistributorSortingEntityParams) {
    super();
    this.type = "distributor-sorting";
    this.entity_version = 1;
    this.value = params.value;
  }
}
